import { Component, OnInit, Input } from '@angular/core';
import { HtmlTextService } from '../../services/html-text.service';

@Component({
  selector: 'pru-wcmdata',
  templateUrl: './wcmdata.component.html',
  styleUrls: ['./wcmdata.component.scss']
})
export class WcmdataComponent implements OnInit {
  @Input() serviceURL: string;
  data: any;

  constructor(private _htmlTextService: HtmlTextService) { }
  ngOnInit() {
    this._htmlTextService.getHTMLText(this.serviceURL).subscribe((serviceData) => { this.data = serviceData; });
  }

}
